import { CHANNEL_VIDEO_LIST_VALUES } from './channel-video-list-values';
export let COMPACT_SHOW_VIDEO_LIST_VALUES = function (COMPACT_SHOW_VIDEO_LIST_VALUES) {
  COMPACT_SHOW_VIDEO_LIST_VALUES[COMPACT_SHOW_VIDEO_LIST_VALUES["EXPAND_ON_CLICK"] = CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK] = "EXPAND_ON_CLICK";
  COMPACT_SHOW_VIDEO_LIST_VALUES[COMPACT_SHOW_VIDEO_LIST_VALUES["ALWAYS_SHOW"] = CHANNEL_VIDEO_LIST_VALUES.ALWAYS_SHOW] = "ALWAYS_SHOW";
  COMPACT_SHOW_VIDEO_LIST_VALUES[COMPACT_SHOW_VIDEO_LIST_VALUES["NEVER_SHOW"] = CHANNEL_VIDEO_LIST_VALUES.NEVER_SHOW] = "NEVER_SHOW";
  return COMPACT_SHOW_VIDEO_LIST_VALUES;
}({});
//# sourceMappingURL=compact-show-video-list.js.map